/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_COURSE_SUCCESS = 'FETCH_COURSE_SUCCESS';
export const CHANGE_COURSE_ENDDATE = 'CHANGE_COURSE_ENDDATE';
export function fetchCourseSuccess(payload) {
    return {type: FETCH_COURSE_SUCCESS, payload: payload};
}

export function changeCourseEndDate(payload) {
    return {type: CHANGE_COURSE_ENDDATE, payload: payload};
}



// WEBPACK FOOTER //
// ./src/_actions/coursedetails.actions.js